import type { LocaleCatalog, MessageSchema } from '../locale';

/**
 * ============================================================================
 * @altkey/i18n - Catalogo Italiano (it)
 * ============================================================================
 * Implementa integralmente `MessageSchema` definito in `../locale.ts`.
 * Qualunque chiave mancante o extra rispetto allo schema causa un errore di
 * compilazione TypeScript: questo garantisce che il catalogo italiano resti
 * sempre sincronizzato al 100% con le altre 4 lingue supportate.
 * ============================================================================
 */

const messages: MessageSchema = {
  common: {
    appName: 'AltKey',
    ok: 'OK',
    cancel: 'Annulla',
    confirm: 'Conferma',
    loading: 'Caricamento in corso…',
    retry: 'Riprova',
    close: 'Chiudi',
    copy: 'Copia',
    copied: 'Copiato negli appunti',
  },
  pairing: {
    title: 'Accoppia i tuoi dispositivi',
    scanQrPrompt: 'Scansiona il codice QR con lo smartphone per accoppiarlo a questo computer',
    enterCodeManually: 'Oppure inserisci manualmente il codice a 6 cifre',
    waitingForDesktop: 'In attesa che il computer si connetta…',
    waitingForMobile: 'In attesa che lo smartphone si connetta…',
    connected: 'Dispositivo connesso',
    disconnected: 'Dispositivo disconnesso',
    expired: 'La sessione di accoppiamento è scaduta. Genera un nuovo codice.',
    invalidCode: 'Codice non valido. Controlla e riprova.',
    keysExchanged: 'Scambio delle chiavi di sicurezza completato',
    scanDevice: 'Inquadra un dispositivo',
    showMyCode: 'Mostra il mio codice',
    hostingPrompt: 'Inquadra questo codice con l’altro telefono',
    goBack: 'Torna Indietro',
    disconnectAction: 'Scollega',
    deviceConnected: '🟢 Dispositivo Connesso',
    backToCategories: '← Torna alle Categorie',
  },
  license: {
    proUnlockedPromo: 'AltKey è in Beta gratuita mondiale: tutte le funzionalità Pro sono sbloccate',
    proUnlockedLicense: 'Funzionalità Pro sbloccate con la tua licenza',
    freeTierPrompt: 'Sblocca le funzionalità Pro con una licenza AltKey',
    invalidLicense: 'La licenseKey inserita non è valida',
    enterLicenseKey: 'Inserisci la tua chiave di licenza',
  },
  search: {
    placeholder: 'Cerca un simbolo, un carattere o una parola chiave…',
    noResults: 'Nessun risultato trovato',
    resultsCount: '{count} risultati trovati',
    filterByCategory: 'Filtra per categoria',
    recentSymbols: 'Simboli usati di recente',
  },
  tofuDetector: {
    title: 'Rilevatore Tofu',
    scanning: 'Scansione dei caratteri mancanti in corso…',
    issuesFound: 'Trovati {count} caratteri non renderizzabili (tofu)',
    noIssuesFound: 'Nessun carattere mancante rilevato: tutto a posto',
    replaceSuggestion: 'Sostituisci con un carattere alternativo compatibile',
  },
  macroGenerator: {
    title: 'Generatore di Macro',
    recordMacro: 'Registra nuova macro',
    stopRecording: 'Interrompi registrazione',
    saveMacro: 'Salva macro',
    macroSaved: 'Macro salvata con successo',
    deleteMacro: 'Elimina macro',
  },
  aiCanvasInput: {
    title: 'Input Canvas con IA',
    drawPrompt: 'Disegna il simbolo che cerchi con il dito o lo stilo',
    recognizing: 'Riconoscimento del disegno in corso…',
    recognitionFailed: 'Non sono riuscito a riconoscere il simbolo. Riprova a disegnarlo.',
    insertSymbol: 'Inserisci simbolo',
  },
  settings: {
    title: 'Impostazioni',
    language: 'Lingua',
    theme: 'Tema',
    themeLight: 'Chiaro',
    themeDark: 'Scuro',
    themeSystem: 'Segui sistema',
    startOnBoot: "Avvia all'accensione del computer",
    notifications: 'Notifiche',
    about: 'Informazioni',
    version: 'Versione {version}',
    checkForUpdates: 'Controlla aggiornamenti',
    signOut: 'Disconnetti',
  },
  home: {
    title: 'Home',
    greeting: 'Ciao, {name}',
    pairWithDesktop: 'Accoppia con il computer',
    recentActivity: 'Attività recente',
    quickActions: 'Azioni rapide',
    noRecentActivity: 'Nessuna attività recente da mostrare',
  },
  errors: {
    generic: 'Si è verificato un errore imprevisto. Riprova.',
    network: 'Errore di connessione. Controlla la tua rete e riprova.',
    sessionExpired: 'La sessione è scaduta. Accedi di nuovo.',
    unauthorized: 'Non sei autorizzato a eseguire questa operazione.',
    notFound: 'Risorsa non trovata.',
  },
};

const catalog: LocaleCatalog = {
  locale: 'it',
  messages,
};

export default catalog;